<template>
  <div class="create">
    <div class="form-panel">
      <createStep1Form
        v-if="active === 1"
        :form="stpe1Data"
        @next="next1"
      />
      <createStep2Form
        v-if="active === 2"
        :info="stpe1Data"
        :form="formData"
        :course-type.sync="courseType"
        @update="updateForm2"
        @prev="prev"
        @next="next2"
      />
    </div>
  </div>
</template>
<script>

import axClient from '@/services';
import createStep1Form from './form/creatStep1.vue';
import createStep2Form from './form/creatStep2.vue';

export default {
  name: 'CaseEdit',
  components: {
    createStep1Form,
    createStep2Form,
  },
  data() {
    return {
      active: 1,
      courseType: 'live',
      stpe1Data: null,
      form: {
        live: null,
        preJob: null,
      },
      isEditType: !!this.$route.params.courseClassId,
    };
  },
  computed: {
    formData() {
      return this.form[this.courseType];
    },
  },
  mounted() {
    this.isEdit();
  },
  beforeDestroy() {
    localStorage.removeItem('courseCreatIndex');
    localStorage.removeItem('courseCreatFirstData');
  },
  methods: {
    prev(active) {
      this.active = active;
      localStorage.setItem('courseCreatIndex', this.active);
    },
    // 更新第一个表单的信息
    updateForm2(data) {
      this.form[this.courseType] = data;
    },
    // 第一步
    next1(data) {
      this.stpe1Data = data;
      this.active = 2;
      localStorage.setItem('courseCreatIndex', this.active);
      localStorage.setItem('courseCreatFirstData', JSON.stringify(this.stpe1Data));
    },
    // 第二步
    next2(data) {
      this.form[[this.courseType]] = data;
      this.submit();
    },
    // 处理表单的数据
    formatFormData() {
      let teacherList;
      if (this.form[this.courseType]) {
        teacherList = this.form[this.courseType].teacherList.map((v) => ({ teacherUserId: v }));
      }
      const data = this._.cloneDeep(this.form);
      data[this.courseType].platformDistributionAmount *= 100;
      data[this.courseType].agencyDistributionAmount *= 100;
      data[this.courseType].counselingAmount *= 100;
      data[this.courseType].videoReviewAmount *= 100;
      data[this.courseType].teacherAmount *= 100;
      data[this.courseType].coursePrice *= 100;
      data[this.courseType].fakePrice *= 100;
      data[this.courseType].teacherList = teacherList;
      return {
        [this.courseType]: data[this.courseType],
      };
    },
    // 提交
    async submit() {
      const {
        courseName,
        courseCategoryId,
        courseSimpleIntro,
      } = this.stpe1Data;
      const id = this.$route.params.courseClassId;
      const data = await axClient.course.upsertCourseDetail({
        id,
        courseName,
        courseCategoryId,
        courseSimpleIntro,
        ...this.formatFormData(),
      });
      if (data) {
        if (this.isEditType) {
          this.$message.success('编辑课程成功');
        } else {
          this.$message.success('新增课程成功');
        }
        this.$router.push({ name: 'CourseList' });
      }
    },
    // 是否编辑信息
    async isEdit() {
      if (this.isEditType) {
        // 编辑
        const data = await axClient.course.getCourseDetail(this.$route.params.courseClassId);
        const {
          courseName, courseCategoryId, courseSimpleIntro,
        } = data;

        const { live, preJob } = data;
        if (live) {
          live.platformDistributionAmount /= 100;
          live.agencyDistributionAmount /= 100;
          live.counselingAmount /= 100;
          live.videoReviewAmount /= 100;
          live.teacherAmount /= 100;
          live.coursePrice /= 100;
          live.fakePrice /= 100;
          live.shareType = null;
          live.shareCustomizePicUrl = null;
          live.shareCodeX = null;
          live.shareCodeY = null;
          live.shareCodeWidth = null;
          live.shareCodeHeight = null;
          const teacherListLive = live.teacherList.map((v) => v.teacherUserId);
          live.teacherList = teacherListLive;
        }
        if (preJob) {
          const teacherListPre = preJob.teacherList.map((v) => v.teacherUserId);
          preJob.platformDistributionAmount /= 100;
          preJob.agencyDistributionAmount /= 100;
          preJob.counselingAmount /= 100;
          preJob.videoReviewAmount /= 100;
          preJob.teacherAmount /= 100;
          preJob.coursePrice /= 100;
          preJob.fakePrice /= 100;
          preJob.shareType = null;
          preJob.shareCustomizePicUrl = null;
          preJob.shareCodeX = null;
          preJob.shareCodeY = null;
          preJob.shareCodeWidth = null;
          preJob.shareCodeHeight = null;
          preJob.teacherList = teacherListPre;
        }
        this.stpe1Data = {
          courseName,
          courseCategoryId,
          courseSimpleIntro,
        };
        this.form = {
          live,
          preJob,
        };
        console.log(this.form);
      }
      if (Number(localStorage.getItem('courseCreatIndex')) === 2 && localStorage.getItem('courseCreatFirstData')) {
        this.active = 2;
        this.stpe1Data = JSON.parse(localStorage.getItem('courseCreatFirstData'));
      }
    },
  },
};
</script>
